import * as React from 'react'

import ProjectDateStore from '~/client/src/shared/stores/ui/ProjectDate.store'

import DayActivitySessionList from './DayActivitySessionList'
import DayActivityStrip from './DayActivityStrip'
import { formatHours } from './format'
import { ISessionGroup, MS_PER_HOUR, Session } from './types'

interface ISessionDayHeaderProps {
  label: string
  totalDurationMs: number
}

const SessionDayHeader: React.FC<ISessionDayHeaderProps> = React.memo(
  ({ label, totalDurationMs }) => {
    return (
      <header className="tw:flex tw:items-baseline tw:justify-between tw:gap-3 tw:px-1">
        <span className="tw:text-label-md-caps-prominent tw:uppercase tw:text-muted-foreground">
          {label}
        </span>
        <span className="tw:text-body-sm tw:text-muted-foreground tw:tabular-nums">
          {formatHours(totalDurationMs / MS_PER_HOUR)}
        </span>
      </header>
    )
  },
)
SessionDayHeader.displayName = 'SessionDayHeader'

interface ISessionDayGroupProps {
  group: ISessionGroup
  projectDateStore?: ProjectDateStore
  hoveredSessionId: string | null
  now: number | null
  onHoverSession: (id: string | null) => void
  onOpenSession: (session: Session) => void
}

const SessionDayGroup: React.FC<ISessionDayGroupProps> = React.memo(
  ({
    group,
    projectDateStore,
    hoveredSessionId,
    now,
    onHoverSession,
    onOpenSession,
  }) => {
    return (
      <section className="tw:flex tw:flex-col tw:gap-2.5">
        <SessionDayHeader
          label={group.label}
          totalDurationMs={group.totalDurationMs}
        />
        <DayActivityStrip
          dayDate={group.date}
          sessions={group.sessions}
          hoveredSessionId={hoveredSessionId}
          now={now}
          onHoverSession={onHoverSession}
          onOpenSession={onOpenSession}
          projectDateStore={projectDateStore}
        />
        <DayActivitySessionList
          sessions={group.sessions}
          hoveredSessionId={hoveredSessionId}
          onHoverSession={onHoverSession}
          onOpenSession={onOpenSession}
          projectDateStore={projectDateStore}
        />
      </section>
    )
  },
)
SessionDayGroup.displayName = 'SessionDayGroup'

export default SessionDayGroup
